import styled from 'styled-components'
import { CheckCircle } from "@material-ui/icons";
import {ClickableIcon} from "components/Buttons/ClickableIcon/ClickableIcon.styles";
import Elipse from 'images/elipse.svg';

export const CheckedCircleIcon = styled(CheckCircle)`
    width: 2rem;
    height: 2rem;
    fill: #4CAF50 !important;
    display: flex;
    align-self: center;
`

export const EliplseIcon = styled(ClickableIcon).attrs({
    src: Elipse,
})`
    width: 2rem;
    height: 2rem;
`

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    align-items: center;
    
    .header {
        color: var(--text-primary, rgba(0, 0, 0, 0.87));
        font-feature-settings: 'clig' off, 'liga' off;
        font-size: 1rem;
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 24px */
        letter-spacing: 0.15px;
    }
    
    .description {
        color: var(--text-secondary, rgba(0, 0, 0, 0.60));
        font-feature-settings: 'clig' off, 'liga' off;
        font-size: 0.75rem;
        font-style: normal;
        font-weight: 700;
        line-height: 166%; /* 19.92px */
        letter-spacing: 0.4px;
    }

    .completedDescription {
        color: var(--success-main, #13CA82);
    }
`